class NfeComentariosModal {
    constructor(gql) {
        this.gql = gql
    }

    $onInit() {
        this.nfe = this.resolve.nfe
        this.nfeId = this.resolve.nfe.id.toInt()
    }

    get textoValido() {
        return (this.texto && this.texto.length <= 200)
    }

    getOrigemTexto(origem) {
        switch (origem) {
            case "AUDITORIA_INTEGRADA_ICMS": 
                return "Auditoria Integrada ICMS"
            case "CENTRAL_ALERTAS": 
                return "Central de Alertas"
        }
    }

    submit(form) {
        if (form.$valid) {
            this.createComentario()
            this.texto = null
        }
    }

    createComentario() {
        const query = gql`
            mutation CreateComentarioAII($empresaId: String!, $nfeId: Int!, $texto: String!, $origem: ComentarioOrigem!) {
                empresa(id: $empresaId) {
                    comentario: createComentario(nfeId: $nfeId, texto: $texto, origem: $origem) {
                        id
                    }
                }
            }
        `

        return this.gql
            .mutate(query, { empresaId: this.resolve.empresaId.toString(), nfeId: this.nfeId, texto: this.texto, origem: this.resolve.origem })
            .then(({ empresa: { comentario } }) => comentario)
    }
}

angular.module('eficienciaFiscalModule')
    .component('nfeComentariosModal', {
        controller: ['gql', NfeComentariosModal],
        bindings: {
            close: '&',
            resolve: '<'
        },
        template: `
        <modal title="Comentários da NF-e" close="$ctrl.close">
            <modal-body>
                <div class="clearfix" style="padding: 0px 10px;">
                    <highlighted ng-hide="$ctrl.nfe.discussao">
                        <main>Esta NF-e ainda não possui comentários.</main>
                        <secondary>
                            Aqui você pode adicionar ideias ou observações que queira compartilhar
                            com outros usuários desta empresa, ou com você mesmo no futuro. 😉
                        </secondary>
                    </highlighted>
                    <div class="col-xs-12">
                        <ul style="list-style-type: none; padding-left: 0">
                            <li ng-repeat="comentario in $ctrl.nfe.discussao.comentarios" style="padding-bottom: 10px">
                                <div>
                                    <span style="float: right">
                                        <i class="text-muted">
                                            {{ comentario.insertedAt | date }} 
                                            {{ comentario.insertedAt | date:'HH:mm' }}
                                            - <i class="text-muted">{{ $ctrl.getOrigemTexto(comentario.origem) }}</i>
                                        </i>                                        
                                    </span> 
                                    <h6 class="text-primary"> {{ comentario.usuario.nome }} </h6> 
                                    {{ comentario.texto }}
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div class="col-xs-12">
                        <form name="form" ng-submit="$ctrl.submit(form)">
                            <textarea name="texto" class="form-control" style="margin-bottom: 10px; resize: vertical;" 
                                      placeholder="Digite aqui seu comentário..." ng-model="$ctrl.texto"></textarea>
                            <div style="float: right">
                                <span class="{{ $ctrl.textoValido ? 'text-muted' : 'text-danger' }}" 
                                    style="margin-right: 10px">
                                    {{ $ctrl.texto.length || 0 }}/200
                                </span>
                                <button class="btn btn-primary" ng-disabled="!$ctrl.textoValido">
                                    Comentar
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </modal-body>
            <modal-footer>
                <button class="btn btn-default" type="button" ng-click="$ctrl.close()">Fechar</button>
            </modal-footer>
        </modal>
        `
    })
